/**
 * "Build Your Sunfade Set" Sunfade Hoodie + Sunfade Pants bundle.
 *
 * Only used by snippets/sunfade-bundle.liquid, rendered solely from the
 * one consolidated Sunfade Hoodie product page. Safe to delete along
 * with that snippet, its CSS, and this file.
 *
 * Both items support Ready to Ship and Preorder / Wait & Save
 * independently, each backed by a real Shopify variant with its own
 * real price and inventory (never a JS-only price). "Add Bundle to
 * Cart" adds the two currently-selected real variants as two separate
 * cart line items via Shopify's native multi-item Ajax Cart API - no
 * bundle SKU, nothing for fulfillment to treat specially. The 20%
 * bundle discount itself is a real Shopify automatic discount (see
 * Admin -> Discounts, "SUNFADE BUNDLE — 20% off Hoodie + Pants") that
 * Shopify applies at cart/checkout time; the percentage used below is
 * for the on-page preview only and is read from a data attribute this
 * section's theme setting controls (see snippets/sunfade-bundle.liquid).
 */
(function () {
  function formatCents(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initBundle(root) {
    var sectionId = root.dataset.sectionId;
    var discountPercent = parseFloat(root.dataset.sfBundleDiscount) || 0;
    var estimatedShipDate = root.dataset.sfShipDate || '';

    var hoodieDataEl = document.getElementById('sf-bundle-hoodie-data-' + sectionId);
    var pantsDataEl = document.getElementById('sf-bundle-pants-data-' + sectionId);
    if (!hoodieDataEl || !pantsDataEl) return;

    var hoodieVariants, pantsVariants;
    try {
      hoodieVariants = JSON.parse(hoodieDataEl.textContent);
      pantsVariants = JSON.parse(pantsDataEl.textContent);
    } catch (e) {
      return;
    }

    var items = {
      hoodie: {
        variants: hoodieVariants,
        productMode: root.dataset.sfHoodiePurchaseMode || '',
        mode: 'ready',
        swatches: root.querySelectorAll('[data-sf-bundle-swatch="hoodie"]'),
        sizeInputs: root.querySelectorAll('[data-sf-bundle-sizes="hoodie"] input'),
        colorNameEl: root.querySelector('[data-sf-bundle-color-name="hoodie"]'),
        purchaseRow: root.querySelector('[data-sf-bundle-purchase="hoodie"]'),
        soldoutBlock: root.querySelector('[data-sf-bundle-soldout="hoodie"]'),
        statusEl: root.querySelector('[data-sf-bundle-status="hoodie"]'),
        notifyBtn: root.querySelector('[data-sf-bundle-notify="hoodie"]'),
        productTitle: 'Sunfade Hoodie'
      },
      pants: {
        variants: pantsVariants,
        productMode: root.dataset.sfPantsPurchaseMode || '',
        mode: 'ready',
        swatches: root.querySelectorAll('[data-sf-bundle-swatch="pants"]'),
        sizeInputs: root.querySelectorAll('[data-sf-bundle-sizes="pants"] input'),
        colorNameEl: root.querySelector('[data-sf-bundle-color-name="pants"]'),
        purchaseRow: root.querySelector('[data-sf-bundle-purchase="pants"]'),
        soldoutBlock: root.querySelector('[data-sf-bundle-soldout="pants"]'),
        statusEl: root.querySelector('[data-sf-bundle-status="pants"]'),
        notifyBtn: root.querySelector('[data-sf-bundle-notify="pants"]'),
        productTitle: 'Sunfade Pants'
      }
    };

    var priceOriginalEl = root.querySelector('[data-sf-bundle-price-original]');
    var priceEl = root.querySelector('[data-sf-bundle-price]');
    var saveBadgeEl = root.querySelector('[data-sf-bundle-save-badge]');
    var ctaBtn = root.querySelector('[data-sf-bundle-cta]');
    var messageEl = root.querySelector('[data-sf-bundle-message]');

    var pantsManuallySet = false;

    function findVariant(item, color, size, type) {
      for (var i = 0; i < item.variants.length; i++) {
        var v = item.variants[i];
        if (v.color === color && v.size === size && v.type === type) return v;
      }
      return null;
    }

    function getSelectedColor(item) {
      var selected = null;
      item.swatches.forEach(function (btn) {
        if (btn.classList.contains('sf-swatch--selected')) selected = btn.dataset.color;
      });
      return selected;
    }

    function getSelectedSize(item) {
      var selected = null;
      item.sizeInputs.forEach(function (input) {
        if (input.checked) selected = input.value;
      });
      return selected;
    }

    function selectSwatch(swatchList, color) {
      swatchList.forEach(function (btn) {
        var isSelected = btn.dataset.color === color;
        btn.classList.toggle('sf-swatch--selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    }

    function updateItem(key) {
      var item = items[key];
      var color = getSelectedColor(item);
      var size = getSelectedSize(item);

      if (item.colorNameEl) item.colorNameEl.textContent = color;

      var gallery = root.querySelector('[data-sf-bundle-gallery="' + key + '"]');
      if (gallery) {
        gallery.querySelectorAll('[data-sf-bundle-image-for="' + key + '"]').forEach(function (wrap) {
          wrap.hidden = wrap.dataset.color !== color;
        });
      }

      var readyVariant = findVariant(item, color, size, 'ready');
      var waitVariant = findVariant(item, color, size, 'wait');

      // Purchase Mode (Ready to Ship / Wait & Save visibility control) -
      // never touches the underlying variant/price data, only which of
      // the two real purchase paths this bundle item offers. Priority:
      // variant-level override -> product-level default -> "Both"
      // (unchanged existing behavior when nothing is configured).
      var modeOverride = (readyVariant && readyVariant.modeOverride) || (waitVariant && waitVariant.modeOverride) || '';
      var effectiveMode = modeOverride || item.productMode || 'Both';
      var readyModeAllowed = effectiveMode === 'Both' || effectiveMode === 'Ready to Ship Only';
      var waitModeAllowed = effectiveMode === 'Both' || effectiveMode === 'Wait & Save Only';

      var readyAvailable = readyModeAllowed && !!(readyVariant && readyVariant.available);
      var waitAvailable = waitModeAllowed && !!(waitVariant && waitVariant.available);

      var statusText = '';
      if (item.mode === 'ready' && !readyAvailable && waitAvailable) {
        item.mode = 'wait';
        statusText = 'Ready to Ship sold out for this size — showing Preorder / Wait & Save.';
      } else if (item.mode === 'wait' && !waitAvailable && readyAvailable) {
        item.mode = 'ready';
        statusText = 'Preorder sold out for this size — showing Ready to Ship.';
      }

      var bothUnavailable = !readyAvailable && !waitAvailable;

      var toggles = item.purchaseRow ? item.purchaseRow.querySelectorAll('[data-sf-bundle-mode]') : [];
      toggles.forEach(function (btn) {
        var mode = btn.dataset.sfBundleMode;
        var variant = mode === 'ready' ? readyVariant : waitVariant;
        var modeAllowed = mode === 'ready' ? readyModeAllowed : waitModeAllowed;
        var priceSpan = btn.querySelector('[data-sf-bundle-mode-price]');
        if (priceSpan && variant) priceSpan.textContent = variant.priceFormatted;
        btn.disabled = !variant || !variant.available;
        btn.style.display = modeAllowed ? '' : 'none';
        btn.classList.toggle('sf-bundle__toggle--selected', mode === item.mode);
      });

      if (item.purchaseRow) item.purchaseRow.hidden = bothUnavailable;
      if (item.soldoutBlock) item.soldoutBlock.hidden = !bothUnavailable;
      if (item.statusEl) item.statusEl.textContent = bothUnavailable ? '' : statusText;

      if (bothUnavailable) {
        var notifyVariant = readyVariant || waitVariant;
        item.notifyContext = {
          productTitle: item.productTitle,
          lines: ['Color: ' + color, 'Size: ' + size],
          variantId: notifyVariant ? notifyVariant.id : ''
        };
      }

      var selectedVariant = item.mode === 'wait' ? waitVariant : readyVariant;
      var selectedAvailable = item.mode === 'wait' ? waitAvailable : readyAvailable;

      return { color: color, size: size, variant: selectedVariant, available: selectedAvailable };
    }

    function update() {
      var hoodieState = updateItem('hoodie');
      var pantsState = updateItem('pants');

      var canAdd = !!(hoodieState.available && pantsState.variant && pantsState.available);

      if (priceOriginalEl && priceEl) {
        if (hoodieState.variant && pantsState.variant) {
          var rawTotal = hoodieState.variant.price + pantsState.variant.price;
          var discounted = Math.round(rawTotal * (1 - discountPercent / 100));
          priceOriginalEl.textContent = formatCents(rawTotal);
          priceOriginalEl.hidden = discountPercent <= 0;
          priceEl.textContent = formatCents(discounted);
        } else {
          priceOriginalEl.textContent = '—';
          priceEl.textContent = '—';
        }
      }
      if (saveBadgeEl) saveBadgeEl.hidden = discountPercent <= 0;

      if (ctaBtn) ctaBtn.disabled = !canAdd;

      return { hoodie: hoodieState, pants: pantsState, canAdd: canAdd };
    }

    items.hoodie.swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var color = btn.dataset.color;
        selectSwatch(items.hoodie.swatches, color);
        if (!pantsManuallySet) {
          var matchExists = items.pants.variants.some(function (v) {
            return v.color === color;
          });
          if (matchExists) selectSwatch(items.pants.swatches, color);
        }
        update();
      });
    });

    items.pants.swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        pantsManuallySet = true;
        selectSwatch(items.pants.swatches, btn.dataset.color);
        update();
      });
    });

    items.hoodie.sizeInputs.forEach(function (input) {
      input.addEventListener('change', update);
    });
    items.pants.sizeInputs.forEach(function (input) {
      input.addEventListener('change', update);
    });

    ['hoodie', 'pants'].forEach(function (key) {
      var item = items[key];
      if (item.purchaseRow) {
        item.purchaseRow.querySelectorAll('[data-sf-bundle-mode]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            item.mode = btn.dataset.sfBundleMode;
            update();
          });
        });
      }
      if (item.notifyBtn && window.NotifyWhenAvailable) {
        item.notifyBtn.addEventListener('click', function () {
          if (item.notifyContext) window.NotifyWhenAvailable.setContext(item.notifyContext);
        });
      }
    });

    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        var state = update();
        if (!state.canAdd) return;

        ctaBtn.disabled = true;
        var originalText = ctaBtn.textContent;
        ctaBtn.textContent = 'Adding...';
        if (messageEl) {
          messageEl.hidden = true;
          messageEl.classList.remove('sf-bundle__message--error');
        }

        var hoodieProps = {
          '_Purchase Type': state.hoodie.variant.type === 'wait' ? 'Wait & Save' : 'Ready to Ship',
          Bundle: 'Sunfade Set'
        };
        var pantsProps = {
          '_Purchase Type': state.pants.variant.type === 'wait' ? 'Wait & Save' : 'Ready to Ship',
          Bundle: 'Sunfade Set'
        };
        if (state.hoodie.variant.type === 'wait') {
          hoodieProps['_Estimated Ship Date'] = estimatedShipDate;
          hoodieProps['Wait & Save'] = 'Order Fulfills Within 60 Days';
        }
        if (state.pants.variant.type === 'wait') {
          pantsProps['_Estimated Ship Date'] = estimatedShipDate;
          pantsProps['Wait & Save'] = 'Order Fulfills Within 60 Days';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: state.hoodie.variant.id, quantity: 1, properties: hoodieProps },
              { id: state.pants.variant.id, quantity: 1, properties: pantsProps }
            ]
          })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error(data.description || data.message || 'Something went wrong.');
              });
            }
            return res.json();
          })
          .then(function () {
            if (messageEl) {
              messageEl.hidden = false;
              messageEl.textContent = 'Both items added to your cart.';
            }
            document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
            if (window.theme && window.theme.settings && window.theme.settings.afterAddToCart === 'drawer') {
              var drawer = document.querySelector('.js-cart-drawer');
              if (drawer && typeof drawer.open === 'function') drawer.open(ctaBtn);
            }
          })
          .catch(function (err) {
            if (messageEl) {
              messageEl.hidden = false;
              messageEl.classList.add('sf-bundle__message--error');
              messageEl.textContent = err.message || 'Something went wrong. Please try again.';
            }
          })
          .finally(function () {
            ctaBtn.textContent = originalText;
            update();
          });
      });
    }

    update();
  }

  function init() {
    document.querySelectorAll('[data-sf-bundle]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
